import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { IsActiveMatchOptions, NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'py-header-navigation-item',
  templateUrl: './header-navigation-item.component.html',
  styleUrls: ['./header-navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderNavigationItemComponent implements OnInit, OnDestroy {
  @HostBinding('class.active')
  isActive: boolean = false;

  private subscription = new Subscription();
  private _active: boolean = false;
  private _disableActive: boolean = false;
  private _url?: string | any[];

  @Input()
  set active(_active: boolean) {
    this._active = _active;
    this.recalculateIsActive();
  }
  get active(): boolean {
    return this._active;
  }

  @Input() set disableActive(disableActive: boolean) {
    this._disableActive = disableActive;
    this.recalculateIsActive();
  }
  get disableActive(): boolean {
    return this._disableActive;
  }

  @Input() set url(url: string | any[]) {
    this._url = url;
    this.recalculateIsActive();
  }
  get url(): string | any[] {
    return this._url;
  }
  @Input() target?: string;
  @Input() ariaLabel?: string;

  @Output() activate = new EventEmitter<void>();

  constructor(
    protected router: Router,
    @Optional() protected link?: RouterLink
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.router.events.subscribe((routerEvent) => {
        if (routerEvent instanceof NavigationEnd) {
          this.recalculateIsActive();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onClick(): void {
    this.activate.emit();
  }

  private recalculateIsActive(): void {
    const urlCommands = !!this.url ? (Array.isArray(this.url) ? this.url : [this.url]) : undefined;
    const urlTree = !!urlCommands ? this.router.createUrlTree(urlCommands) : undefined;
    const routerLinkActive = !!urlTree
      ? this.router.isActive(urlTree, {
          fragment: 'ignored',
          matrixParams: 'ignored',
          paths: 'exact',
          queryParams: 'ignored',
        } as IsActiveMatchOptions)
      : false;
    this.isActive = (this.active || routerLinkActive) && !this.disableActive;
  }
}
